import React from "react";
import { useNavigate } from "react-router-dom";
import { FaFacebookF, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";
import "../css/footer.css";

export default function Footer() {
  const navigate = useNavigate();

  // ✅ FIXED: Now perfectly matches the SearchBar logic!
  const handleRouteClick = (from, to) => {
    const today = new Date().toISOString().slice(0, 10);

    // Create the exact same URL parameters as the SearchBar
    const query = new URLSearchParams({
      from: from,
      to: to,
      date: today,
      passengers: 1, // Default to 1 passenger
      type: "flexible"
    }).toString();

    // Navigate to the correct search page
    navigate(`/search?${query}`);

    // Smooth scroll to top so they see the results instantly
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Popular Routes */}
        <div className="footer-section">
          <h3 className="footer-heading">Popular Routes</h3>
          <ul className="footer-list popular-routes">
            <li onClick={() => handleRouteClick("Indore,Madhya pradesh", "Delhi,India")}>
              <span className="city">Indore</span> <span className="arrow">→</span> <span className="city">Delhi</span>
            </li>
            <li onClick={() => handleRouteClick("Bhopal,Madhya pradesh", "Ujjain,Madhya pradesh")}>
              <span className="city">Bhopal</span> <span className="arrow">→</span> <span className="city">Ujjain</span>
            </li>
            <li onClick={() => handleRouteClick("Mumbai,Maharashtra", "Pune,Maharashtra")}>
              <span className="city">Mumbai</span> <span className="arrow">→</span> <span className="city">Pune</span>
            </li>
            <li onClick={() => handleRouteClick("Pune,Maharashtra", "Aurangabad,Bihar")}>
              <span className="city">Pune</span> <span className="arrow">→</span> <span className="city">Aurangabad</span>
            </li>
            <li onClick={() => handleRouteClick("Gurgaon,Haryana", "Jaipur,Rajasthan")}>
              <span className="city">Gurgaon</span> <span className="arrow">→</span> <span className="city">Jaipur</span>
            </li>
            <li onClick={() => handleRouteClick("Bengaluru,Karnataka", "Chittoor,Andhra Pradesh")}>
              <span className="city">Bengaluru</span> <span className="arrow">→</span> <span className="city">Chittoor</span>
            </li>
          </ul>
        </div>

        {/* Services */}
        <div className="footer-section">
          <h3 className="footer-heading">Our Services</h3>
          <ul className="footer-list">
            <li>🚗 Ride Sharing Platform</li>
            <li>📍 Google Maps Integration</li>
            <li>🔐 Secure Authentication</li>
            <li>🧾 Post & Browse Rides</li>
            <li>📱 Mobile-Friendly UI</li>
          </ul>
        </div>

        {/* Resources */}
        <div className="footer-section">
          <h3 className="footer-heading">Resources</h3>
          <ul className="footer-list">
            <li><a href="/about">About Us</a></li>
            <li><a href="/faqs">FAQs</a></li>
            <li><a href="/contact">Contact</a></li>
            <li><a href="/terms">Terms of Service</a></li>
          </ul>
        </div>

        {/* Community / Promo */}
        <div className="footer-section">
          <h3 className="footer-heading">Join Vyango</h3>
          <p className="footer-note">
            Save money, share rides, and travel smarter. Connect with thousands of verified riders today!
          </p>
          <button className="footer-button" onClick={() => navigate("/phoneauth")}>
            Join Now
          </button>
          <div className="footer-social">

            <a href="https://facebook.com/vyango" target="_blank" rel="noopener noreferrer">
              <FaFacebookF />
            </a>

            <a href="https://twitter.com/Official_Vyango" target="_blank" rel="noopener noreferrer">
              <FaTwitter />
            </a>

            <a href="https://instagram.com/vyango.app" target="_blank" rel="noopener noreferrer">
              <FaInstagram />
            </a>

            <a href="https://www.linkedin.com/in/vyango/" target="_blank" rel="noopener noreferrer">
              <FaLinkedin />
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Line */}
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Vyango. All rights reserved.</p>
      </div>
    </footer>
  );
}